import { useCallback } from "react";
import { useGetState, useSetState } from "components/ReduxProvider";

const FEEDBACK_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

const isRecent = (createdAt?: number): boolean =>
  typeof createdAt === "number" && createdAt > Date.now() - FEEDBACK_TIMEOUT_MS;

export function useLastFeedback() {
  const lastFeedback = useGetState("lastFeedback");
  const setLastFeedback = useSetState("lastFeedback");

  const lastValid = isRecent(lastFeedback?.createdAt) ? lastFeedback : undefined;

  const clear = useCallback(() => setLastFeedback(undefined), [setLastFeedback]);

  const start = useCallback(
    (subject: string | undefined) =>
      setLastFeedback({
        relatedTo: subject,
        messages: [],
        createdAt: Date.now(),
        helpfulAnswer: undefined
      }),
    [setLastFeedback]
  );

  const markHelpful = useCallback(
    (helpful: boolean) => {
      if (!lastFeedback) return;
      setLastFeedback({ ...lastFeedback, helpfulAnswer: helpful });
    },
    [lastFeedback, setLastFeedback]
  );

  return { last: lastValid, clear, start, markHelpful };
}
